module.exports = __webpack_public_path__ + "static/share-cdebca5dd22e6f93c7045979c665c127.jpg";